import {SaleReportType} from '../sale';
import {Dropdown} from './dropdown';

const SALE_REPORT_TYPE_OPTIONS_FR: Dropdown<SaleReportType>[] = [
  {name: 'Externe', value: SaleReportType.EXTERNAL},
  {name: 'Interne', value: SaleReportType.INTERNAL},
];

const SALE_REPORT_TYPE_OPTIONS_EN: Dropdown<SaleReportType>[] = [
  {name: 'External', value: SaleReportType.EXTERNAL},
  {name: 'Internal', value: SaleReportType.INTERNAL},
];

export const SALE_REPORT_TYPE_OPTIONS = {
  en: SALE_REPORT_TYPE_OPTIONS_EN,
  fr: SALE_REPORT_TYPE_OPTIONS_FR,
};
